module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "private-chat"
    }
  }, [(!_vm.newConversationMode) ? [_c('h2', [_vm._v("Conversations")]), _vm._v(" "), _c('ul', {
    class: [{
      'shrunk': _vm.selectedConversation
    }],
    attrs: {
      "id": "private-chat-conversations"
    }
  }, _vm._l((_vm.conversations), function(conversation) {
    return _c('li', {
      class: [{
        'selected': _vm.selectedConversation && _vm.selectedConversation.chatId === conversation.chatId
      }],
      on: {
        "click": function($event) {
          _vm.selectConversation(conversation)
        }
      }
    }, [_c('span', {
      staticClass: "partner-alias"
    }, [(_vm.showNotification(conversation)) ? _c('i', {
      staticClass: "fas fa-bell new-message-notification"
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(conversation.partnerAlias) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "timestamp"
    }, [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(conversation.lastMessageTime)))])])
  })), _vm._v(" "), (_vm.selectedConversation) ? _c('h2', {
    attrs: {
      "id": "private-chat-conversation-header"
    }
  }, [_vm._v("Chat with " + _vm._s(_vm.selectedConversation.partnerAlias))]) : _vm._e(), _vm._v(" "), (_vm.selectedConversation && _vm.showingHistoryDates) ? [_c('ul', {
    attrs: {
      "id": "private-chat-history-dates"
    }
  }, _vm._l((_vm.historyDates), function(historyDate) {
    return _c('li', {
      staticClass: "history-date-item",
      on: {
        "click": function($event) {
          _vm.selectHistoryDate(historyDate)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(historyDate.messageCount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(historyDate.day)))])])
  }))] : _vm._e(), _vm._v(" "), (_vm.selectedConversation && !_vm.showingHistoryDates) ? [(_vm.selectedHistoryDate) ? _c('span', {
    attrs: {
      "id": "private-chat-history-header"
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-arrow-left",
    on: {
      "click": _vm.showHistoryDates
    }
  }), _vm._v("\n            History: " + _vm._s(_vm._f("formatDateWithoutTime")(_vm.selectedHistoryDate.day)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    ref: "chatMessages",
    attrs: {
      "id": "private-chat-messages"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('li', [_c('div', {
      staticClass: "avatar-container"
    }, [_c('avatar', {
      attrs: {
        "profile-data": message.from,
        "profile-type": "developer",
        "size": "very-small",
        "show-xp-info": false
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "message-details"
    }, [_c('span', {
      staticClass: "message-from"
    }, [_c('router-link', {
      attrs: {
        "to": '/Developer/' + message.from.stringUrl
      }
    }, [_vm._v(_vm._s(message.from.alias))])], 1), _vm._v(" "), _vm._l((message.messages), function(individualMessage) {
      return _c('div', {
        staticClass: "individual-message"
      }, [_c('markdown-content', {
        attrs: {
          "classes": "message-message",
          "content": individualMessage.message
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "message-date"
      }, [_vm._v(_vm._s(_vm._f("formatDateCondensed")(message.timestamp)))])], 1)
    })], 2)])
  }))] : _vm._e(), _vm._v(" "), (_vm.selectedConversation) ? _c('div', {
    attrs: {
      "id": "private-chat-options"
    }
  }, [_c('div', {
    class: ['option', {
      selected: _vm.showingHistoryDates || _vm.showingHistoryDateMessages
    }],
    attrs: {
      "title": "History"
    },
    on: {
      "click": _vm.toggleHistoryDates
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-history"
  })]), _vm._v(" "), (_vm.audioNotificationsEnabled) ? _c('div', {
    staticClass: "option",
    attrs: {
      "title": "Turn off Audio Notifications"
    },
    on: {
      "click": function($event) {
        _vm.toggleAudioNotifications('off')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-volume-up"
  })]) : _vm._e(), _vm._v(" "), (!_vm.audioNotificationsEnabled) ? _c('div', {
    staticClass: "option",
    attrs: {
      "title": "Turn on Audio Notifications"
    },
    on: {
      "click": function($event) {
        _vm.toggleAudioNotifications('on')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-volume-off"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedConversation && !_vm.showingHistoryDates && !_vm.showingHistoryDateMessages) ? _c('form', {
    attrs: {
      "id": "private-chat-input"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Type to chat...",
      "maxlength": "450"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Send"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendMessage($event)
      }
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.newConversationMode) ? [_c('h2', {
    attrs: {
      "id": "private-chat-conversation-header-new-conversation"
    }
  }, [_vm._v("Chat with " + _vm._s(_vm.newConversationAlias))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "private-chat-messages-new-conversation"
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "id": "private-chat-input-new-conversation"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Type to chat...",
      "maxlength": "450"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Send"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendNewConversationMessage($event)
      }
    }
  })])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe309fec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/PrivateChat/PrivateChat.vue
// module id = 926
// module chunks = 2